import { Component } from '@angular/core';

import {Router} from '@angular/router';
import { environment } from '../../../../environments/environment';

declare function require(moduleName: string): any;

@Component({
  selector: 'tr-footer',
  templateUrl: './footer.component.html',
  //styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  envName: string = (environment.platform !== '') ? `(${environment.platform})` : '';
  version: string = require('../../../../../package.json').version;
  constructor(private router: Router) {}
  
  onUpdatePassword(e: Event) {
    this.router.navigate(['/authentication/updatePassword']);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/footer/footer.component.ts